import React, { useEffect } from 'react'
import FirstScreenOfLandingPage from './components/FirstScreenOfLandingPage'
import { useLocation } from 'react-router-dom'
import styles from './LandingPage.module.scss'

type Props = {}

const LandingPage: React.FC<Props> = (props: Props) => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const section = document.getElementById(location.hash.substring(1));
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }
        else {
            window.scrollTo(0, 0);
        }
    }, [location]);

    return (
        <>
            <FirstScreenOfLandingPage />
            <div className={styles.newDealsContainer}>
                {/* <NewDeals /> */}
            </div>
            {/* <BenefitsOfSolar />
            <Carousel />
            <GotQuestions /> */}
        </>
    )
}

export default LandingPage
